import React, { useContext, useEffect } from "react";
import { View, Text, StyleSheet, TextInput, Dimensions } from "react-native";
import { useNavigate, useParams } from "react-router-dom";
import { colors } from "../../common/styles/colors";
import { VotingContext } from "./VotingNavigation";
import _ from "lodash";
import { CommonLoading } from "../../components/CommonLoading";
import { CommonButton } from "../../components/buttons";
import { MascotBlackLooks } from "../../common/icons/mascot_black_looks";
import { fonts } from "../../common/styles/fonts";
import { format } from "date-fns";
import { getMeetingTypes } from "../../utils/use-meeting-data";

export const LandingVotingPage = () => {
  const navigate = useNavigate();
  const { meetingUuid } = useParams<{ meetingUuid: string }>();

  const { name, setName, authorName, meeting, getMeeting, meetingError } =
    useContext(VotingContext);

  useEffect(() => {
    if (!meeting && meetingUuid) {
      getMeeting(meetingUuid);
    }
  }, [meetingUuid]);

  useEffect(() => {
    if (meetingError || (meeting && _.isNumber(meeting.generated_index))) {
      navigate(`../app/not-found`, { replace: true });
    }
  }, [meeting]);

  const getDistrict = (item: any) => {
    if (!item.district) return "";
    return " in " + item.district;
  };

  const getTitle = (item: any) =>
    item.category &&
    (item.category.length === 1 ? "for" + item.category[0] : "") +
      getDistrict(item);

  const addUser = () => {
    navigate(`../app/action/${meetingUuid}`, {
      replace: true,
    });
  };

  // @ts-ignore
  const meetingTypes = getMeetingTypes(meeting);

  return (
    <>
      {meeting ? (
        <View
          style={{
            height: Dimensions.get("window").height,
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View style={styles.screen}>
            <MascotBlackLooks />
            <Text
              style={[
                fonts.largeText_bold,
                {
                  textAlign: "center",
                  marginBottom: 8,
                  marginTop: 41,
                },
              ]}
            >
              {authorName} is inviting you for{" "}
              {meetingTypes.length === 1
                ? meetingTypes[0].toLowerCase()
                : "gaddering"}
            </Text>
            <Text
              style={[
                fonts.mediumText_regular,
                {
                  marginBottom: 41,
                  textAlign: "center",
                },
              ]}
            >
              {getTitle(meeting)} <br />
              {meeting.date &&
                format(
                  new Date(meeting.date),
                  "do 'of' LLL',' E hh:mm aaaaa'm'"
                )}
              .
            </Text>
            <TextInput
              style={[fonts.mediumText_regular, styles.input]}
              placeholder="Enter your name"
              placeholderTextColor={colors.gray20}
              value={name}
              onChangeText={(text) => setName(text)}
            />
            <Text style={[fonts.mediumText_regular, { marginBottom: 72 }]}>
              Choose the perfect place together!
            </Text>
            <CommonButton
              type="black"
              size="medium"
              title="Let’s go"
              textStyle={fonts.mediumText_bold}
              onPress={() => addUser()}
            />
          </View>
        </View>
      ) : (
        <CommonLoading />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  screen: {
    height: "100%",
    maxWidth: 500,
    width: "100%",

    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 86,
    paddingBottom: 100,
    alignItems: "center",
  },
  input: {
    height: 46,
    borderRadius: 10,
    textAlign: "center",
    marginBottom: 24,
    maxWidth: 340,
    width: "100%",
    backgroundColor: colors.LightGrayishYellow,
    borderWidth: 1,
    borderColor: colors.gray81,
  },
});
